<template>
  <div class="map-search">
    <van-search
      v-model="search"
      shape="round"
      :background="'transparent'"
      placeholder="请输入搜索关键词"
      @blur="listVisible = false"
      @search="handleSearch"
    />
    <div v-show="listVisible" class="mask" @click="listVisible = false" />
    <van-list
      v-show="listVisible"
      v-model="loading"
      :finished="true"
      finished-text="没有更多了"
    >
      <div v-for="i in result" :key="i.id" class="suggestion-item" @click="handleSelectPosition(i)">
        <div style="font-size: 14px;line-height: 1;">
          {{ i.name }}
        </div>
        <div style="font-size: 12px;line-height: 2;color: #aaa;">
          {{ i.district }}
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import axios from 'axios'
import { AmapApiKey } from '@/constant/common'

export default {
  name: 'SearchInput',
  data() {
    return {
      search: '',
      loading: false,
      listVisible: false,
      result: []
    }
  },
  methods: {
    handleSearch(queryString, cb) {
      if (!queryString) return
      this.loading = true
      this.listVisible = true
      axios.get('https://restapi.amap.com/v3/assistant/inputtips', {
        params: {
          key: AmapApiKey,
          keywords: queryString,
          city: '四川省', // 搜索范围
          citylimit: true // false可能出现city以外的搜索结果
        }
      }).then(({ data }) => {
        if (data.status === '1') {
          this.result = data.tips.filter(i => {
            return i.location.constructor === String
          })
        } else {
          this.$toast('地点搜索失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelectPosition(val) {
      this.listVisible = false
      this.search = val.name
      this.$emit('select', {
        center: val.location.split(','),
        zoom: 18
      })
    }
  }
}
</script>

<style lang="less" scoped>
.map-search {
  position: relative;
}
.van-search {
  position: relative;
  z-index: 1;
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  width: 100vw;
  height: 100vh;
}
.van-list {
  position: relative;
  margin: 0 10px;
  background: #fff;
  border-radius: 4px;
  max-height: 50vh;
  overflow-y: auto;
  z-index: 1;
}
.suggestion-item {
  padding: 4px 10px;
  &:active {
    background-color: #f2f3f5;
  }
}
</style>
